import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { Observable } from 'rxjs';
import {Config} from '../../../@vendor/config/config';
import {Card} from './models/card.model';
@Injectable({
  providedIn: 'root'
})
export class CardService {

  constructor(private config: Config, private http: HttpClient) { }
  getOwnedCards(): Observable<any> {
    const param = {};
    const url = this.config.serverUrl + `api/card/ownedCards`;
    return this.http.get(url, param);
  }
  getDestinationCards(): Observable<any> {
    const param = {};
    const url = this.config.serverUrl + `api/card/destinationCards`;
    return this.http.get(url, param);
  }
  addCard(card): Observable<any> {
    const param = card;
    const url = this.config.serverUrl + `api/card/registerUserOwnedCard`;
    return this.http.post(url, param);
  }
  editSavedCard(card, cardUniqueId) {
    const param = card;
    const url = this.config.serverUrl + `api/card/ownedCards/${cardUniqueId}`;
    return this.http.post(url, param);
  }
  deleteCard(cardUniqueId): Observable<any> {
    const param = {};
    const url = this.config.serverUrl + `api/card/ownedCards/${cardUniqueId}`;
    return this.http.delete(url, param);
  }
  getCardIban(cardUniqueId): Observable<any> {
    const param = {};
    const url = this.config.serverUrl + `api/card/${cardUniqueId}/toIban`;
    return this.http.get(url, param);
  }
  blockCard(param, cardUniqueId): Observable<any> {
    const url = this.config.serverUrl + `api/card/${cardUniqueId}/block`;
    return this.http.post(url, param);
  }
  setDefaultCard(cardUniqueId): Observable<any> {
    const param = {};
    const url = this.config.serverUrl + `api/card/${cardUniqueId}/default`;
    return this.http.post(url, param);
  }
  getCardDepositStatement(cardUniqueId, param): Observable<any>  {
    const url = this.config.serverUrl + `api/card/${cardUniqueId}/ENBankDepositStatement`;
    return this.http.post(url, param);
  }
  getCardTransactionHistory(resourceUniqueId, pageSize, upperBound): Observable<any>  {
    let url = this.config.serverUrl + `api/transaction?resourceType=Card&resourceUniqueId=${resourceUniqueId}&pageSize=${pageSize}`;
    if (upperBound !== '') {
      url += `&upperBound=${upperBound}`;
    }
    return this.http.get(url);
  }
  getCardInquery(panNumber): Observable<any> {
    const param = {};
    const url = this.config.serverUrl + `api/card/inquiry?pan=${panNumber}`;
    return this.http.get(url, param);
  }
  getCardDesign(value): Card {
    const result = new Card();
    const banksList = JSON.parse(localStorage.getItem('bankList'));
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < banksList.length; i++) {
      // tslint:disable-next-line:prefer-for-of
      for (let j = 0; j < banksList[i].bins.length; j++) {
        if ( banksList[i].bins[j] === value) {
          return banksList[i];
        }
      }
    }
    return result;
  }
  deleteDestinationCard(cardUniqueId): Observable<any> {
    const url = this.config.serverUrl + `api/card/destinationCards/${cardUniqueId}`;
    return this.http.delete(url, {});
  }
  editDestinationCard(cardObj, cardUniqueId): Observable<any> {
    const url = this.config.serverUrl + `api/card/destinationCards/${cardUniqueId}`;
    return this.http.post(url, cardObj);
  }
  callMicard(): Observable<any> {
    const url = this.config.serverUrl + `api/micard`;
    return this.http.get(url);
  }
}
